import React from 'react';
import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';
import { useSidebarOpen } from '@shared/providers/SidebarContext';
import { useTheme } from '@shared/providers/theme/ThemeContext';

export type TreatmentReportFormBottomBarMode = 'create' | 'edit';

export interface TreatmentReportFormBottomBarProps {
  mode: TreatmentReportFormBottomBarMode;
  isSubmitting: boolean;
  isDeleting?: boolean;
  formId: string;
  onBack: () => void;
  onDelete?: () => void;
  onPrint?: () => void;
  canPrint?: boolean;
}

const TreatmentReportFormBottomBar: React.FC<TreatmentReportFormBottomBarProps> = ({
  mode,
  isSubmitting,
  isDeleting = false,
  formId,
  onBack,
  onDelete,
  onPrint,
  canPrint = false,
}) => {
  const sidebarOpen = useSidebarOpen();
  const { colors } = useTheme();
  const showDelete = mode === 'edit' && typeof onDelete === 'function';
  const isBusy = isSubmitting || isDeleting;

  const left = (
    <div className="flex gap-2">
      {mode === 'edit' && (
        <AppButton
          type="primary"
          disabled={!canPrint || isBusy}
          onClick={onPrint}
          className="px-4 py-2 font-medium text-white bg-green-600 rounded hover:!bg-green-700 disabled:bg-green-600 disabled:text-white disabled:opacity-50"
        >
          施術報告書印刷
        </AppButton>
      )}
    </div>
  );

  const right = (
    <div className="flex gap-4">
      {showDelete && (
        <AppButton
          type="primary"
          disabled={isBusy}
          loading={isDeleting}
          onClick={onDelete}
          icon={<i className="fa fa-trash-o" aria-hidden="true" />}
          className="px-4 py-2 font-medium text-white bg-blue-400 rounded hover:!bg-blue-500 disabled:bg-blue-300 disabled:text-white disabled:cursor-not-allowed"
        >
          削除
        </AppButton>
      )}
      <AppButton
        type="default"
        onClick={onBack}
        disabled={isBusy}
        className="px-4 py-2 font-medium rounded"
      >
        一覧に戻る
      </AppButton>
      <AppButton
        type="primary"
        htmlType="submit"
        form={formId}
        loading={isSubmitting}
        disabled={isBusy}
        className="px-12 py-2 font-medium text-white rounded"
        style={{ backgroundColor: colors.secondary, borderColor: colors.secondary }}
      >
        <i
          className={mode === 'create' ? 'fa fa-plus mr-2' : 'fa fa-paper-plane mr-2'}
          aria-hidden="true"
        />{' '}
        {mode === 'create' ? '登録' : '更新'}
      </AppButton>
    </div>
  );

  return (
    <BottomBar
      variant="action"
      visible={true}
      left={left}
      right={right}
      fixed
      className={sidebarOpen ? 'left-60' : 'left-0'}
    />
  );
};

export default TreatmentReportFormBottomBar;
